import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api'

const accessibilitySiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'accessibility'

export const config = { site: accessibilitySiteConfig, name }
